// extracted by mini-css-extract-plugin
export var aboutColumn = "main-person-module--aboutColumn--2be6e";
export var bioInMain = "main-person-module--bioInMain--209e6";
export var companyLogo = "main-person-module--companyLogo--8f58f";
export var textAbout = "main-person-module--textAbout--99944";
export var titleAbout = "main-person-module--titleAbout--3727e";